'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash.mapvalues');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (object, filter) {
  return (0, _lodash2.default)(object, function (value, key) {
    return typeof filter === 'function' && !filter(key) || value !== null ? value : 'blank';
  });
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/utils/mapNullToBlank.js
 ** module id = 428
 ** module chunks = 0
 **/